import React from 'react';

const FinishWindowOrderPage = () => {
  return <div style={{ padding: '24px' }} />;
};

export default FinishWindowOrderPage;
